module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_12-dd4cf333f0caa64aa5355133c17a90d3.png";